import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Typography,
  Table,
  TableCell,
  TableBody,
  TableRow,
  TableHead,
  TableContainer,
  Card,
  TextField,
  FormControl,
  Grid,
  CardContent,
  Dialog,
  Stack,
  IconButton,
  InputAdornment,
  DialogContent,
  DialogActions,
  DialogTitle,
  Tooltip,
  Box,
  Select,
  InputLabel,
  MenuItem,
  Breadcrumbs,
  Link,
  Container,
  useTheme
} from "@mui/material";
import Scrollbar from "src/components/Scrollbar";
// import axios from '../axios';
import axios from "axios";
import { getURL, jsonToParam, jsonToFormData } from "src/utils/config";
import Iconify from "src/components/Iconify";
import Page from "src/components/Page";
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { Edit, Delete, Visibility, VisibilityOff } from "@mui/icons-material";
import { getAppStorageItem } from 'src/utils/storageProxy';

const getAssignedLocationsFromStorage = () => {
  try {
    const assignedLocationsRaw = getAppStorageItem('assigned_locations');
    if (!assignedLocationsRaw) return [];

    const parsedAssignedLocations = JSON.parse(assignedLocationsRaw);
    const assignedLocations = Array.isArray(parsedAssignedLocations)
      ? parsedAssignedLocations
      : [];

    return assignedLocations
      .map((locationItem) => ({
        ID: Number(locationItem?.ID ?? locationItem?.id ?? 0),
        Location: String(locationItem?.Location || locationItem?.name || '').trim(),
      }))
      .filter((locationItem) => locationItem.ID > 0);
  } catch (error) {
    console.error('Failed to read assigned_locations from storage:', error);
    return [];
  }
};

const AddUserAccess = () => {
  const theme = useTheme();
  const [IsNeed2FAAuthentication, setIsNeed2FAAuthentication] = useState(0);
  const [email, setEmail] = useState("");
  const [agentName, setAgentName] = useState("");
  const [userNewName, setNewUsername] = useState("");
  const [password, setPassword] = useState("");

  const [addError, setAddError] = useState("");
  const [updateError, setUpdateError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [agentNameError, setagentNameError] = useState("");
  const [userNewNameError, setuserNewNameError] = useState("");
  const [passwordError, setpasswordTypeError] = useState("");
  const [showForm, setShowForm] = useState(false);


  const [showPassword, setShowPassword] = useState(false);
  const [showEditPassword, setShowEditPassword] = useState(false);
  const [visiblePasswordIndex, setVisiblePasswordIndex] = useState(null);

  //Edit Dailog box
  const [openDialogEdit, setOpenDialogEdit] = useState(false);

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState("md");

  const [isEdited, setIsEdited] = useState(false);
  const [prvValue, setPrvValue] = useState("");

  const [successEditDialog, setSuccessEditDialog] = useState(false);

  const [userData, setUserData] = useState({});

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const [openMessage, setOpenMessage] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState(false);
  const [subLogin, setSubLoginList] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [indexHist, setIndexHist] = useState(null);
  const formRef = useRef(null);

  const AUTHORIZATION = `Bearer ${localStorage.getItem("access_token")}`;

  const storedProperty = localStorage.getItem('Location');
  const AssignClient = localStorage.getItem('AssignClient');

  const [property, setProperty] = useState(() => {
    const stored = localStorage.getItem('selectedProperty');
    return stored ? parseInt(stored) : null;
  });
  const [properties, setProperties] = useState([]);

  //let clientId = Number(localStorage.getItem("ID"));

  let clientId = 0;
  if(localStorage.getItem('Type') === 'merge'){
    clientId = localStorage.getItem('ID');
  }
  else{
    clientId = localStorage.getItem('client_id');
  }

  useEffect(() => {
    if(AssignClient!=='' && storedProperty!=='') {
      const assignedLocations = getAssignedLocationsFromStorage();
      setProperties(assignedLocations);

      const stored = localStorage.getItem('selectedProperty');
      if (stored) {
        const found = assignedLocations.find((loc) => loc.ID === parseInt(stored));
        if (found) {
          setProperty(found.ID);
        }
      } else {
        const first = assignedLocations[0];
        if (first) {
          setProperty(first.ID);
          localStorage.setItem('selectedProperty', first.ID);
        }
      }
    }
  },[])


  useEffect(() => {
    getSubLogins();
  }, [property]);

  
  const getSubLogins = () => {
    const userId = (property !== null) ? Number(property) : clientId;
    
    axios({
      method: "get",
      url: `${getURL("/client/client-users")}?client_id=${userId}&type=share`,
      headers: {
        Authorization: `${AUTHORIZATION}`,
      },
      validateStatus: function (status) {
        return status >= 200 || status === 400;
      },
    }).then(function (response) {
      if (response.status === 200) {
        setSubLoginList(response.data);
      } else {
        console.log(response.data);
      }
    });
  };

  const toggleForm = () => {
    if (showForm) {
      setShowForm(false);
      handleClear();
    } else {
      setShowForm(true);
    }
  };

  const [dialogData, setDialogData] = useState({
    email: "",
    agentName: "",
    userNewName: "",
    password: "",
    IsNeed2FAAuthentication:0
  });

  const [editedData, seteditedData] = useState({
    Id: "",
    UserID: "",
    email: "",
    agentName: "",
    userNewName: "",
    password: "",
    IsNeed2FAAuthentication:0
  });

  const [successDialog, setSuccessDialog] = useState(false);

  
  const handleAuthenicationChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, IsNeed2FAAuthentication: event.target.value });
      setIsNeed2FAAuthentication(event.target.value);
    } else {
      seteditedData({ ...editedData, IsNeed2FAAuthentication: event.target.value });
    }
  };

  const handleEmailChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, email: event.target.value });
      setEmail(event.target.value);
    } else {
      seteditedData({ ...editedData, email: event.target.value });
    }
  };

  const handleAgentNameChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, agentName: event.target.value });
      setAgentName(event.target.value);
    } else {
      seteditedData({ ...editedData, agentName: event.target.value });
    }
  };

  const handleUsername = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, userNewName: event.target.value });
      setNewUsername(event.target.value);
    } else {
      setIsEdited(true);
      setPrvValue(editedData.userNewName);
      seteditedData({ ...editedData, userNewName: event.target.value });
    }
  };

  const handlePasswordChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, password: event.target.value });
      setPassword(event.target.value);
    } else {
      seteditedData({ ...editedData, password: event.target.value });
    }
  };

  function isUniqueValue(newDisplayName, newUserName, newEmail, subLogin) {
    let isValid = true;
    if (newDisplayName === newUserName) {
      setagentNameError("Profile Name and UserName should be different");
      setuserNewNameError("Profile Name and UserName should be different");
      isValid = false;
    }

    for (const login of subLogin) {
      if (login.displayname === newDisplayName) {
        setagentNameError("Profile Name Already Exist");
        isValid = false;
      }

      if (login.Name === newUserName) {
        setuserNewNameError("User Name Already Exist");
        isValid = false;
      }

      if (login.Email === newEmail) {
        setEmailError("Email Already Exists");
        isValid = false;
      }
    }
    return isValid; // Return true if no match is found
  }

  function isUniqueEditValue(newDisplayName, newUserName, newEmail, subLogin) {
    let id = editedData.Id;
    let isValid = true;

    if (newDisplayName === newUserName) {
      setEditProfileNameError("Profile Name and UserName should be different");
      setEditNameError("Profile Name and UserName should be different");
      isValid = false;
    }

    for (const login of subLogin) {
      if (login.Id === id) continue;
      if (login.DisplayName === newDisplayName && login.Id !== id) {
        setEditProfileNameError("Please Enter the Profile Name");
        isValid = false;
      }
      if (login.UserName === newUserName && login.Id !== id) {
        setEditNameError("Please Enter the User Name");
        isValid = false;
      }

      if (login.Email === newEmail) {
        setEditEmailError("Email Already Exists");
        isValid = false;
      }
    }
    return isValid; // Return true if no match is found
  }

  const handleSubmit = () => {
    let Count = 0;

    clearFieldErrors();

    const addEmail = email.trim();
    const addAgentName = agentName.trim();
    const addUserNewName = userNewName.trim();
    const addPassword = password.trim();
    const addIsNeed2FAAuthentication = IsNeed2FAAuthentication;

    if (!addEmail) {
      setEmailError("Please Enter the Email");
      Count = 1;
    }

    // Check for valid email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (addEmail && !emailRegex.test(addEmail)) {
      setEmailError("Please Enter the Valid Email");
      Count = 1;
    }

    if (!addAgentName) {
      setagentNameError("Please Enter the Profile Name");
      Count = 1;
    }

    if (!addUserNewName) {
      setuserNewNameError("Please Enter the User Name");
      Count = 1;
    }

    if (!addPassword) {
      setpasswordTypeError("Please Enter the Password");
      Count = 1;
    }

    if (Count === 0) {
      if (!isUniqueValue(addAgentName, addUserNewName, addEmail, subLogin)) {
      } else {

        const userId = (property !== null) ? String(property) : String(clientId);

        const data = {
          UserID: userId,
          displayname: addAgentName,
          Name: addUserNewName,
          Password: addPassword,
          Email: addEmail,
          IsNeed2FAAuthentication: addIsNeed2FAAuthentication,
          Type: "share",
        };

        axios({
          method: "post",
          url: getURL("/client/add-client-users"),
          data: data,
          headers: {
            Authorization: `${AUTHORIZATION}`,
          },
          validateStatus: function (status) {
            return status >= 200 || status === 400;
          },
        }).then(function (response) {
          if (response.status === 200) {
            handleClear();
            getSubLogins();
            setSuccessDialog(true);

            setShowForm(false);
          } else {
            //console.log("addError:", response.data.detail);
            setAddError(response.data.detail);

            setTimeout(() => {
              clearAlertMsgs();
            }, 3000);
          }
        });
      }
    }
  };

  const clearAlertMsgs = () => {
    setAddError("");
    setUpdateError("");
  };

  const clearFieldErrors = () => {
    clearAlertMsgs();

    setEditEmailError("");
    setEditNameError("");
    setEditProfileNameError("");
    setEditedPasswordError("");

    setEmailError("");
    setagentNameError("");
    setuserNewNameError("");
    setpasswordTypeError("");
  };

  const handleClear = () => {
    clearFieldErrors();

    setEmail("");
    setAgentName("");
    setNewUsername("");
    setPassword("");
    setIsNeed2FAAuthentication(0);
  };

  const handleEdit = (data, index) => {
    setIndexHist(index);
    const userId = (property !== null) ? String(property) : String(clientId);
    const editData = {
      Id: data.Id,
      email: data.Email,
      agentName: data.DisplayName,
      userNewName: data.UserName,
      password: data.Password,
      UserID: userId,
      IsNeed2FAAuthentication:parseInt(data.IsNeed2FAAuthentication)
    };

    setShowMessage(false);
    seteditedData(editData);
    //setOpenDialogEdit(true);

    setOriginalData(JSON.parse(JSON.stringify(subLogin[index])));
  };

  //console.log('editedData:', editedData)

  const [editNameError, setEditNameError] = useState("");
  const [editedPasswordError, setEditedPasswordError] = useState("");
  const [showMessage, setShowMessage] = useState(false);

  const [editProfileNameError, setEditProfileNameError] = useState("");
  const [editEmailError, setEditEmailError] = useState("");
  const editIsNeed2FAAuthentication = parseInt(editedData.IsNeed2FAAuthentication);

  const handleUpdated = () => {
    let count = 0;

    clearFieldErrors();

    const userId = (property !== null) ? String(property) : String(clientId);

    const editEmail = editedData.email.trim();
    const editAgentName = editedData.agentName.trim();
    const editUserNewName = editedData.userNewName.trim();
    const editPassword = editedData.password.trim();

    if (!editEmail) {
      setEditEmailError("Please Enter the Email");
      count = 1;
    }

    // Check for valid email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (editEmail && !emailRegex.test(editEmail)) {
      setEditEmailError("Please Enter the Valid Email");
      count = 1;
    }

    if (!editAgentName) {
      setEditProfileNameError("Please Enter the Profile Name");
      count = 1;
    }

    if (!editUserNewName) {
      setEditNameError("Please Enter the User Name");
      count = 1;
    }

    if (!editPassword) {
      setEditedPasswordError("Please Enter the Password");
      count = 1;
    }

    if (
      count === 0 &&
      editPassword !== "" &&
      editPassword !== null &&
      editEmail !== "" &&
      editEmail !== null &&
      editAgentName !== "" &&
      editAgentName !== null &&
      editUserNewName !== "" &&
      editUserNewName !== null
    ) {
      if (
        !isUniqueEditValue(
          editAgentName,
          editUserNewName,
          editedData.email,
          subLogin
        )
      ) {
        // console.log("The agentName or userNewName already exists in the list.");
        // Modify the new values to be unique
        // For example, append some random number or string to ensure uniqueness
      } else {
        const updateData = {
          ID: editedData.Id,
          UserID: userId,
          Email: editEmail,
          displayname: editAgentName,
          Name: editUserNewName,
          Password: editPassword,
          IsNeed2FAAuthentication:editIsNeed2FAAuthentication,
          Type: "share",
          Status: 1,
        };
        axios({
          method: "put",
          url: getURL("/client/update-client-users"),
          data: updateData,
          headers: {
            Authorization: `${AUTHORIZATION}`,
          },
          validateStatus: function (status) {
            return status >= 200 || status === 400;
          },
        }).then(function (response) {
          if (response.status === 200) {
            setOpenDialogEdit(false);
            handleClear();
            getSubLogins();
            setSuccessEditDialog(true);
            setIndexHist(null);
          } else {
            //console.log('updateError:', response.data.detail);
            setUpdateError(response.data.detail);

            setTimeout(() => {
              clearAlertMsgs();
            }, 3000);
          }
        });
      }
    }
  };

  const handleClose = () => {
    setOpenDialogEdit(false);
    setIsEdited(false);
    setPrvValue("");
    setShowMessage(false);
    setOpenMessage(false);
    setDeleteMessage(false);
    setUserData({});

    setEditEmailError("");
    setEditNameError("");
    setEditProfileNameError("");
    setEditedPasswordError("");
  };

  // Function to handle the icon click
  const handlePasswordVisibilityToggle = (index) => {
    setVisiblePasswordIndex(visiblePasswordIndex === index ? null : index);
  };

  const handleDelete = (data) => {
    setDeleteMessage(true);
    setUserData(data);
  };

  const deleteUser = () => {
    const deleteUserData = {
      ID: userData.Id,
    };

    axios({
      method: "delete",
      url: getURL(`/client/delete`),
      data: jsonToFormData(deleteUserData),
      headers: {
        Authorization: `${AUTHORIZATION}`,
      },
      validateStatus: function (status) {
        return status >= 200 || status === 400;
      },
    }).then(function (response) {
      if (response.status === 200) {
        setDeleteMessage(false);
        getSubLogins();
        //console.log("User deleted successfully!");
      } else {
        console.log("deleteError:", response.data.detail);
      }
    });
  };

  const updateUserStatus = () => {
    const newStatus = userData.Status === 1 ? 0 : 1;

    const updateData = {
      ID: userData.Id,
      Status: newStatus,
    };

    axios({
      method: "put",
      url: getURL("/client/update-status"),
      data: jsonToParam(updateData),
      headers: {
        Authorization: `${AUTHORIZATION}`,
      },
      validateStatus: function (status) {
        return status >= 200 || status === 400;
      },
    }).then(function (response) {
      if (response.status === 200) {
        setOpenMessage(false);
        getSubLogins();
        //console.log("Status updated successfully!");
      } else {
        console.log("updateError:", response.data.detail);
      }
    });
  };

  return (
    <Page title="Share Login Access">
      <Container maxWidth="xxl" sx={{ p: 0 }}>

        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4">Share Login Access</Typography>
            <Button
              variant="contained"
              onClick={toggleForm}
              startIcon={<AddIcon />}
            >
              Add User
            </Button>
          </Box>
          <Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
            <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>
              Share Login Access
            </Typography>
          </Breadcrumbs>
        </Box>

        {properties.length > 1 &&
          <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth>
                  <InputLabel>Location</InputLabel>
                  <Select
                    value={property || ''}
                    label="Location"
                    onChange={(e) => {
                      const val = e.target.value;
                      setProperty(val);
                      localStorage.setItem('selectedProperty', val);
                    }}
                  >
                    {properties.map((event) => (
                      <MenuItem key={event.ID} value={event.ID}>
                        {event.Location}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
          </Grid>
        }

        <Dialog open={showForm} onClose={toggleForm} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            Add User
            <IconButton size="small" onClick={toggleForm}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2} sx={{ pt: 0.5 }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="email"
                  variant="outlined"
                  value={email}
                  label="Email"
                  placeholder="Enter Email"
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => handleEmailChange(e, "add")}
                  error={!!emailError}
                  helperText={emailError || " "}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="agent-name"
                  variant="outlined"
                  value={agentName}
                  label="Profile Name"
                  placeholder="Enter Profile Name"
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => handleAgentNameChange(e, "add")}
                  error={!!agentNameError}
                  helperText={agentNameError || " "}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="userName"
                  label="User Name"
                  variant="outlined"
                  value={userNewName}
                  placeholder="Enter User Name"
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => handleUsername(e, "add")}
                  error={!!userNewNameError}
                  helperText={userNewNameError || " "}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  name="userpassword"
                  label="Password"
                  placeholder="Enter Password"
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => handlePasswordChange(e, "add")}
                  value={password}
                  type={showPassword ? "text" : "password"}
                  error={!!passwordError}
                  helperText={passwordError || " "}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
                          <Iconify icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"} />
                        </IconButton>
                      </InputAdornment>
                    ),
                    autoComplete: "new-password",
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-labell">Email Authentication</InputLabel>
                  <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={IsNeed2FAAuthentication}
                  label="Email Authentication"
                  onChange={(e) => handleAuthenicationChange(e, "add")}
                >
                  <MenuItem sx={{
                                  '&.Mui-selected': {
                                      backgroundColor: 'rgba(143, 148, 148, 0.91)'
                                  }
                              }}  value="1">Required</MenuItem>
                  <MenuItem sx={{
                                  '&.Mui-selected': {
                                      backgroundColor: 'rgba(143, 148, 148, 0.91)'
                                  }
                              }}  value="0">Not Required</MenuItem>
                </Select>
              </FormControl>
              </Grid>
              {addError && (
                <Grid item xs={12}>
                  <Typography color="error" variant="body2">{addError}</Typography>
                </Grid>
              )}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleClear}>Clear</Button>
            <Button variant="contained" onClick={handleSubmit} disabled={isButtonDisabled}>Add</Button>
          </DialogActions>
        </Dialog>

        <Card variant="outlined">
          <TableContainer sx={{ maxHeight: 600 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="center" sx={{ bgcolor: 'background.neutral', fontWeight: 600, width: 60 }}>S.No</TableCell>
                  <TableCell align="center" sx={{ bgcolor: 'background.neutral', fontWeight: 600 }}>Email</TableCell>
                  <TableCell align="center" sx={{ bgcolor: 'background.neutral', fontWeight: 600 }}>Profile Name</TableCell>
                  <TableCell align="center" sx={{ bgcolor: 'background.neutral', fontWeight: 600 }}>User Name</TableCell>
                  <TableCell align="center" sx={{ bgcolor: 'background.neutral', fontWeight: 600 }}>Password</TableCell>
                  <TableCell align="center" sx={{ bgcolor: 'background.neutral', fontWeight: 600 }}>Email Authentication</TableCell>
                  <TableCell align="center" sx={{ bgcolor: 'background.neutral', fontWeight: 600, width: 200 }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {subLogin.length > 0 ? (
                  subLogin.map((data, index) => (
                    <TableRow key={index} hover>
                      <TableCell align="center">{index + 1}</TableCell>

                      <TableCell align="center">
                        {indexHist === index ? (
                          <TextField
                            fullWidth
                            size="small"
                            id="email"
                            variant="outlined"
                            value={editedData.email}
                            label="Email"
                            onChange={(e) => handleEmailChange(e, "edit")}
                            error={!!editEmailError}
                            helperText={editEmailError || " "}
                            sx={{ my: 1 }}
                          />
                        ) : data.Email}
                      </TableCell>

                      <TableCell align="center">
                        {indexHist === index ? (
                          <TextField
                            fullWidth
                            size="small"
                            id="agent-name"
                            variant="outlined"
                            value={editedData.agentName}
                            label="Profile Name"
                            onChange={(e) => handleAgentNameChange(e, "edit")}
                            error={!!editProfileNameError}
                            helperText={editProfileNameError || " "}
                            sx={{ my: 1 }}
                          />
                        ) : data.DisplayName}
                      </TableCell>

                      <TableCell align="center">
                        {index === indexHist ? (
                          <TextField
                            fullWidth
                            size="small"
                            id="userName"
                            label="User Name"
                            variant="outlined"
                            value={editedData.userNewName}
                            onChange={(e) => handleUsername(e, "edit")}
                            error={!!editNameError}
                            helperText={editNameError || " "}
                            sx={{ my: 1 }}
                          />
                        ) : data.UserName}
                      </TableCell>

                      <TableCell align="center">
                        {indexHist === index ? (
                          <TextField
                            fullWidth
                            size="small"
                            name="userpassword"
                            label="Password"
                            onChange={(e) => handlePasswordChange(e, "edit")}
                            value={editedData.password}
                            type={showEditPassword ? "text" : "password"}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton edge="end" onClick={() => setShowEditPassword(!showEditPassword)}>
                                    <Iconify icon={showEditPassword ? "eva:eye-fill" : "eva:eye-off-fill"} />
                                  </IconButton>
                                </InputAdornment>
                              ),
                              autoComplete: "new-password",
                            }}
                            error={!!editedPasswordError}
                            helperText={editedPasswordError || " "}
                            sx={{ my: 1 }}
                          />
                        ) : (
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
                            <Typography variant="body2">
                              {visiblePasswordIndex === index ? data.Password : "••••••••"}
                            </Typography>
                            <IconButton size="small" onClick={() => handlePasswordVisibilityToggle(index)}>
                              {visiblePasswordIndex === index ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                            </IconButton>
                          </Box>
                        )}
                      </TableCell>

                      <TableCell align="center" style={{width:"200px"}}>
                        {indexHist === index ? (
                          <Grid container spacing={2} sx={{ paddingBottom:"0px", marginTop: "-20px", marginLeft: "0px" }}>
                          <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-labell">Email Authentication</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={editedData.IsNeed2FAAuthentication}
                              label="Email Authentication"
                              onChange={(e) => handleAuthenicationChange(e, "edit")}
                              sx={{
                                height: 40,               // 🔑 Same as TextField small
                                '& .MuiSelect-select': {
                                  padding: '8.5px 14px',  // 🔑 Matches TextField padding
                                  display: 'flex',
                                  alignItems: 'center',
                                },
                              }}
                            >
                              <MenuItem sx={{
                                              '&.Mui-selected': {
                                                  backgroundColor: 'rgba(143, 148, 148, 0.91)'
                                              }
                                          }}  value="1">Required</MenuItem>
                              <MenuItem sx={{
                                              '&.Mui-selected': {
                                                  backgroundColor: 'rgba(143, 148, 148, 0.91)'
                                              }
                                          }}  value="0">Not Required</MenuItem>
                            </Select>
                          </FormControl>
                          </Grid>
                        ) : (
                          (data.IsNeed2FAAuthentication === 0) ? "Not Required" : "Required"
                        )}
                      </TableCell>

                      <TableCell align="center">
                        {indexHist === index ? (
                          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                            <Button size="small" variant="contained" onClick={handleUpdated}>Save</Button>
                            <Button size="small" variant="outlined" onClick={() => {
                              setIsEdited(false);
                              setIndexHist(null);
                              setEditEmailError("");
                              setEditedPasswordError("");
                              setEditProfileNameError("");
                            }}>Cancel</Button>
                          </Box>
                        ) : (
                          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                            <Button
                              size="small"
                              variant="contained"
                              onClick={() => handleEdit(data, index)}
                              disabled={data.Status === 0}
                            >
                              Edit
                            </Button>
                            <Button
                              size="small"
                              variant="contained"
                              color="error"
                              onClick={() => handleDelete(data)}
                            >
                              Delete
                            </Button>
                          </Box>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center" sx={{ py: 4, color: 'text.secondary' }}>
                      No Data
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>

        <Dialog open={openMessage} onClose={handleClose}>
          <DialogContent>
            <Stack
              //  direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ maxWidth: 350, textAlign: "center" }}
            >
              <Iconify
                icon={"eva:alert-triangle-outline"}
                sx={{ fontSize: 92, color: "#ffb2a3" }}
              />
              <Typography sx={{ color: "gray" }} variant="h5">
                {" "}
                Are you sure you want to{" "}
                {userData.Status === 1 ? "Disable" : "Enable"} the user :{" "}
                {userData.DisplayName}?
              </Typography>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={handleClose} sx={{
                color: theme.palette.primary.contrastText,
                '&:hover': {
                  color: theme.palette.primary.contrastText,
                }
            }}>
              No
            </Button>
            <Button variant="contained" onClick={updateUserStatus} sx={{
                color: theme.palette.primary.contrastText,
                '&:hover': {
                  color: theme.palette.primary.contrastText,
                }
              }}>
              Yes
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={deleteMessage} onClose={handleClose}>
          <DialogContent>
            <Stack
              //  direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ maxWidth: 350, textAlign: "center" }}
            >
              <Iconify
                icon={"eva:alert-triangle-outline"}
                sx={{ fontSize: 92, color: "#ffb2a3" }}
              />
              <Typography sx={{ color: "gray" }} variant="h5">
                {" "}
                Are you sure you want to delete the user: {userData.DisplayName}?
              </Typography>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={handleClose} sx={{
              color: theme.palette.primary.contrastText,
                '&:hover': {
                  color: theme.palette.primary.contrastText,
                }
            }}>
              No
            </Button>
            <Button variant="contained" onClick={deleteUser} sx={{
                color: theme.palette.primary.contrastText,
                '&:hover': {
                  color: theme.palette.primary.contrastText,
                }
              }}>
              Yes
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={successDialog} onClose={() => setSuccessDialog(false)}>
          <DialogContent>
            <Stack
              justifyContent="center"
              alignItems="center"
              sx={{ maxWidth: 350, textAlign: "center" }}
            >
              <Typography sx={{ color: "gray" }} variant="h5">
                User added successfully!
              </Typography>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" sx={{
              color: theme.palette.primary.contrastText,
              '&:hover': {
                color: theme.palette.primary.contrastText,
              }
            }} onClick={() => setSuccessDialog(false)}>
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={successEditDialog}
          onClose={() => setSuccessEditDialog(false)}
        >
          <DialogContent>
            <Stack
              justifyContent="center"
              alignItems="center"
              sx={{ maxWidth: 350, textAlign: "center" }}
            >
              <Typography sx={{ color: "gray" }} variant="h5">
                User updated successfully!
              </Typography>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              sx={{
                color: theme.palette.primary.contrastText,
                '&:hover': {
                  color: theme.palette.primary.contrastText,
                }
              }}
              onClick={() => setSuccessEditDialog(false)}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
};

export default AddUserAccess;
